import { Injectable } from '@angular/core';

import { ConvoParticipantService } from './convo-participant.service';
// import { GeoService } from './geo.service';
import { PerformerService } from './performer.service';
import { SceneService } from './scene.service';
import { ShareScreenParticipantService } from './share-screen/share-screen-participant.service';

@Injectable()
export class CleanUpTasksService {
  public initialized = false;

  // FIXME: This is how theses services get loaded/injected. Find a better solution
  public constructor(
    _performerService: PerformerService,
    _shareScreenParticipantService: ShareScreenParticipantService,
    _convoService: ConvoParticipantService,
    _sceneService: SceneService,
    // _geoService: GeoService,
  ) {
    // noop
  }
}
